import '@/javascript/application'

import initFlashMessages from '@/javascript/components/flash'
import SignInForm from '@vuejs/views/sign-in/SignInForm'

import { createVueApp } from './createVueApp'

initFlashMessages()

createVueApp(SignInForm).mount('#signInApp')
